import TriadQualitiesSpellInputs from "./TriadQualitiesSpellInputs";
import PrimaryTriadsSpellInputs from "./PrimaryTriadsSpellInputs";
import TonicDominantSpellInputs from "./TonicDominantSpellInputs";
import QuestionLayout from "./QuestionLayout";

function AccidentalButtons({ onSelect }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {[
        { label: "♭", value: "♭" },
        { label: "♯", value: "♯" }
      ].map(({ label, value }) => (
        <button
          key={value}
          tabIndex={-1}
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(value);
          }}
          style={{
            fontSize: 16,
            padding: "2px 6px",
            cursor: "pointer"
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

function insertAccidental(text, acc) {
  return (text || "") + acc;
}

export default function MajorTriadSpellWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  if (config.variant === "triad-qualities") return <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
    <TriadQualitiesSpellInputs config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>
  </QuestionLayout>;
  if (config.variant === "primary-triads") return <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
    <PrimaryTriadsSpellInputs config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>
  </QuestionLayout>;
  if (config.variant === "tonic-dominant") {
    return (
      <QuestionLayout
        number={config.number} prompt={config.prompt} points={config.points}
        mode={mode} feedback={feedback}
      >
        <TonicDominantSpellInputs config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>
      </QuestionLayout>
    );
  }
  const activeField = value.__activeField || null;

  function setAnswer(id, v) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      [id]: v.toUpperCase()
    });
  }

  function setActiveField(id) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      __activeField: id
    });
  }

  function clearActiveField() {
    if (mode !== "edit") return;

    const next = { ...value };
    delete next.__activeField;
    onChange(next);
  }

  function inputBorder(id) {
    if (mode !== "review") return "1px solid #aaa";

    return feedback?.parts?.[id]?.correct
      ? "2px solid #2e7d32"
      : "2px solid #c62828";
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 50,
    fontSize: 20,
    flexWrap: "wrap",
    // The accidental buttons are absolutely positioned below the inputs, so
    // they do not contribute to the row height. QuestionLayout can clip that
    // vertical overflow; reserve the same clearance used by RelMmWidget.
    paddingBottom: mode === "edit" ? 36 : 0
  }}
>
  {config.rows.map((row) => {
    const thirdId = `${row.id}_third`;
    const fifthId = `${row.id}_fifth`;

    return (
      <div
        key={row.id}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10
        }}
      >
        <span
          style={{
            fontWeight: 600,
            minWidth: 30
          }}
        >
          {row.root}
        </span>

        {[thirdId, fifthId].map((id) => (
          <div
            key={id}
            style={{
              position: "relative"
            }}
          >
            <input
              value={value[id] || ""}
              disabled={mode !== "edit"}
              onFocus={() => setActiveField(id)}
              onBlur={() => clearActiveField()}
              onChange={(e) =>
                setAnswer(id, e.target.value)
              }
              style={{
                width: config.inputWidth || 50,
                height: 34,
                textAlign: "center",
                fontSize: 18,
                background: "transparent",
                outline: "none",

                border: "none",
                borderBottom:
                  mode === "review"
                    ? feedback?.parts?.[id]?.correct
                      ? "2px solid #2e7d32"
                      : "2px solid #c62828"
                    : "2px solid #000",

                borderRadius: 0
              }}
            />

            {activeField === id &&
              mode === "edit" && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    marginTop: 4,
                    zIndex: 10
                  }}
                >
                  <AccidentalButtons
                    onSelect={(acc) =>
                      setAnswer(
                        id,
                        insertAccidental(
                          value[id] || "",
                          acc
                        )
                      )
                    }
                  />
                </div>
              )}
          </div>
        ))}
      </div>
    );
  })}
</div>
    </QuestionLayout>
  );
}